export default __webpack_public_path__ + "static/media/training-active.b97c57d1.svg";